import { Device, DeviceSummary } from '../types/api';
import { 
    DEFAULT_EXPORT_DEVICE_FIELDS,
    DEFAULT_EXPORT_SUMMARY_FIELDS,
    DEFAULT_EXPORT_DEVICE_IGNORE_FIELDS
} from '../constants/deviceFields';

const needsQuoting = (value: any): boolean => {
    if (value === null || value === undefined) return false;
    const stringValue = String(value);
    // Quote if contains comma, double quote, newline, or carriage return
    return stringValue.includes(',') || 
           stringValue.includes('"') || 
           stringValue.includes('\n') || 
           stringValue.includes('\r');
};

const formatCSVValue = (value: any): string => {
    if (value === null || value === undefined) return '';
    
    const stringValue = String(value);
    if (!needsQuoting(value)) return stringValue;
    
    // Escape double quotes by doubling them and wrap the field in quotes
    return `"${stringValue.replace(/"/g, '""')}"`;
};

export interface ExportOptions {
    fields?: string[];
    includeHeaders?: boolean;
}

export const exportToCSV = (
    data: Device[] | DeviceSummary[], 
    filename: string,
    options?: ExportOptions
) => {
    if (!data || data.length === 0) return;

    // Determine if we're dealing with Device or DeviceSummary data
    const isDeviceData = 'NetworkComputerName' in data[0];
    
    // Get base fields to export
    let fieldsToExport = options?.fields || 
        (isDeviceData ? DEFAULT_EXPORT_DEVICE_FIELDS : DEFAULT_EXPORT_SUMMARY_FIELDS);

    // Apply ignore list for device exports if using defaults
    if (isDeviceData && !options?.fields) {
        fieldsToExport = fieldsToExport.filter(f => !DEFAULT_EXPORT_DEVICE_IGNORE_FIELDS.includes(f));
    }

    // Filter out any fields that don't exist in the data
    const validFields = fieldsToExport.filter(field => field in data[0]);

    const csvContent = [
        // Add header row if not explicitly disabled
        ...(options?.includeHeaders === false ? [] : [validFields.map(formatCSVValue).join(',')]),
        // Add data rows
        ...data.map(row => 
            validFields.map(field => formatCSVValue((row as any)[field])).join(',')
        )
    ].join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    if (link.download !== undefined) {
        const url = URL.createObjectURL(blob);
        link.setAttribute('href', url);
        link.setAttribute('download', filename);
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
}; 